module.exports = __webpack_public_path__ + "img/returnClassify.9a0955a2.png";